export enum FilterOperator {
  contains,
  notContains,
  equals,
  notEqual,
  startsWith,
  endsWith,
  greaterThan,
  lessThan,
  greaterThanOrEqual,
  lessThanOrEqual,
  inRange,
  notBlank,
  blank,
}
